import type { ReactNode } from 'react';
import type { CheckStatus } from '../lib/types.js';
import { cx } from './classes.js';
import { StatusGlyph } from './StatusGlyph.js';

/**
 * One of the four summary cells at the top of a profile (wireframe §5a):
 * glyph + word, the fact, then the source and its read time.
 */
export function SummaryCell({
  status,
  title,
  fact,
  source,
  first = false,
}: {
  status: CheckStatus;
  title: string;
  fact: ReactNode;
  source: ReactNode;
  first?: boolean;
}) {
  return (
    <div
      className={cx(
        'flex flex-col gap-2 px-6 py-[22px]',
        !first && 'border-l border-line',
      )}
    >
      <div className="flex items-center gap-2.5">
        <StatusGlyph status={status} />
        <span className="text-[15px] font-semibold">{title}</span>
      </div>
      <div className="text-[14px] text-ink">{fact}</div>
      <div className="text-[12px] text-mute">{source}</div>
    </div>
  );
}
